import gql from 'graphql-tag';

const LIST = gql`
  query PesertaDiklat($page: Int!, $keyword: String) {
    ptkDiklatList(first: 10, page: $page, keyword: $keyword) {
      paginatorInfo {
        currentPage
        lastPage
        total
      }
      data {
        paud_peserta_diklat_id
        nama
        ptk_id
        tahun
        angkatan
        tgl_mulai
        tgl_selesai
        instansi_lpd {
          nama
        }
        k_verval_paud
        m_verval_paud {
          singkat
          keterangan
        }
        k_diklat_paud
        m_diklat_paud {
          singkat
          keterangan
          k_diklat_paud
        }
      }
    }
  }
`;

const INSTANSI = gql`
  query GetInstansi {
    ptkLpdList(first: 1000) {
      data {
        instansi_id
        instansi {
          nama
        }
      }
    }
  }
`;

const MASTERS = gql`
  query getMasters {
    diklat_paud: master(table: "diklat_paud") {
      key
      value
    }
    jenjang_diklat_paud: master(table: "jenjang_diklat_paud") {
      key
      value
    }
  }
`;

const CREATE = gql`
  mutation CreateKlaim(
    $nama: String!
    $k_diklat_paud: Int!
    $k_tingkat_diklat_paud: Int!
    $tgl_mulai: Date!
    $tgl_selesai: Date!
    $instansi_id_lpd: Int
    $satminkal: String!
    $file: Upload!
    $catatan: String
  ) {
    ptkDiklatCreate(
      nama: $nama
      k_diklat_paud: $k_diklat_paud
      k_tingkat_diklat_paud: $k_tingkat_diklat_paud
      tgl_mulai: $tgl_mulai
      tgl_selesai: $tgl_selesai
      instansi_id_lpd: $instansi_id_lpd
      satminkal: $satminkal
      file: $file
      catatan: $catatan
    ) {
      nama
    }
  }
`;

const UPDATE = gql`
  mutation UpdateKlaim(
    $paud_peserta_diklat_id: Int!
    $nama: String!
    $k_diklat_paud: Int!
    $k_tingkat_diklat_paud: Int!
    $tgl_mulai: Date!
    $tgl_selesai: Date!
    $instansi_id_lpd: Int
    $satminkal: String!
    $file: Upload
    $catatan: String
  ) {
    ptkDiklatUpdate(
      paud_peserta_diklat_id: $paud_peserta_diklat_id
      nama: $nama
      k_diklat_paud: $k_diklat_paud
      k_tingkat_diklat_paud: $k_tingkat_diklat_paud
      tgl_mulai: $tgl_mulai
      tgl_selesai: $tgl_selesai
      instansi_id_lpd: $instansi_id_lpd
      satminkal: $satminkal
      file: $file
      catatan: $catatan
    ) {
      nama
    }
  }
`;

const DETAIL = gql`
  query DetailKlaim($id: Int!) {
    ptkDiklat(paud_peserta_diklat_id: $id) {
      nama
      k_diklat_paud
      k_tingkat_diklat_paud
      tgl_mulai
      tgl_selesai
      instansi_id_lpd
      satminkal
      alasan
      catatan
      url
      k_verval_paud
      m_diklat_paud {
        keterangan
      }
      m_tingkat_diklat_paud {
        keterangan
      }
      m_verval_paud {
        keterangan
      }
      instansi_lpd {
        nama
        m_kota {
          keterangan
        }
        m_propinsi {
          keterangan
        }
      }
    }
  }
`;

const DELETE = gql`
  mutation DeleteKlaim($paud_peserta_diklat_id: Int!) {
    ptkDiklatDelete(paud_peserta_diklat_id: $paud_peserta_diklat_id)
  }
`;

const SUBMIT = gql`
  mutation SubmitKlaim($paud_peserta_diklat_id: Int!) {
    ptkDiklatSubmit(paud_peserta_diklat_id: $paud_peserta_diklat_id)
  }
`;

const RESET = gql`
  mutation ResetKlaim($paud_peserta_diklat_id: Int!) {
    ptkDiklatReset(paud_peserta_diklat_id: $paud_peserta_diklat_id)
  }
`;

const BERKAS_SAVE = gql`
  mutation BerkasSave($file: [PtkBerkasSaveBerkas!]!) {
    ptkBerkasSave(berkas: $file)
  }
`;

export default { LIST, INSTANSI, MASTERS, CREATE, UPDATE, DELETE, SUBMIT, RESET, DETAIL, BERKAS_SAVE };
